'use strict';

/* globals define, socket, app, ajaxify, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/organizations/details', [
	'coverPhoto',
	'pictureCropper',
	'components',
	'translator',
	'bootbox',
	'alerts'
], function (coverPhoto, pictureCropper, components, translator, bootbox, alerts) {
	var	Organization = {};

	Organization.init = function () {
		if (ajaxify.data.organization.isOwner) {
			coverPhoto.init(
				components.get('organization/cover'),
				function (imageData, position, callback) {
					socket.emit('plugins.organizations.updateCover', {
						organizationId: ajaxify.data.organization.id,
						imageData: imageData,
						position: position,
					}, callback);
				},
				function () {
					pictureCropper.show({
						title: '[[groups:upload-group-cover]]',
						socketMethod: 'plugins.organizations.uploadCover',
						aspectRatio: NaN,
						allowSkippingCrop: true,
						restrictImageDimension: false,
						paramName: 'organizationId',
						paramValue: ajaxify.data.organization.id,
					}, function (imageUrlOnServer) {
						imageUrlOnServer = (!imageUrlOnServer.startsWith('http') ? config.relative_path : '') + imageUrlOnServer + '?' + Date.now();
						components.get('organization/cover').css('background-image', 'url(' + imageUrlOnServer + ')');
					});
				},
				removeCover
			);
		}
	};

	function removeCover() {
		translator.translate('[[groups:remove_group_cover_confirm]]', function (translated) {
			bootbox.confirm(translated, function (confirm) {
				if (!confirm) {
					return;
				}

				socket.emit('plugins.organizations.removeCover', {
					organizationId: ajaxify.data.organization.id,
				}, function (err) {
					if (!err) {
						ajaxify.refresh();
					} else {
						alerts.error(err.message);
					}
				});
			});
		});
	}

	return Organization;
});
